export const PINIA_PERSIST_KEY_PREFIX = 'pinia-';

const encodePersistStoreId = !import.meta.env.DEV;

export function persistStoreKey(storeId: string, encodeId = encodePersistStoreId): string {
  return PINIA_PERSIST_KEY_PREFIX + (encodeId ? btoa(storeId) : storeId);
}

export function persistStoreIdFromKey(key: string, encodeId = encodePersistStoreId): string | null {
  if (!key.startsWith(PINIA_PERSIST_KEY_PREFIX)) {
    return null;
  }

  const raw = key.slice(PINIA_PERSIST_KEY_PREFIX.length);

  if (!encodeId) {
    return raw;
  }

  try {
    return atob(raw);
  } catch {
    return null;
  }
}
